import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAccounts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <rect
      width={6.066}
      height={8.721}
      x={18.25}
      y={12.15}
      rx={1.82}
      transform="rotate(90 18.25 12.15)"
    />
    <path
      fillRule="evenodd"
      d="M10.47 3.57a1.82 1.82 0 0 0-1.819-1.82H3.57a1.82 1.82 0 0 0-1.82 1.82v2.426a1.82 1.82 0 0 0 1.82 1.82h.895A3.12 3.12 0 0 1 7.42 5.7h3.05zm3.89 5.25A1.82 1.82 0 0 0 12.54 7H7.46a1.82 1.82 0 0 0-1.82 1.82v2.426a1.82 1.82 0 0 0 1.82 1.82h.873a3.12 3.12 0 0 1 2.987-2.216h3.04z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAccounts;
